import { useMemo } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import useLocalization from '../../../hooks/useLocalization';
import StyledForm from '../shared/StyledForm';
import { useKapopay } from '../../../hooks/payment/useKapopay';
import { requiredNumber } from '../../../utils/validation';
import FormNumberInput from '../../molecules/form-elements/FormNumberInput';

const KapopayDepositForm = () => {
  const { t } = useLocalization();
  const {
    depositMutation: { mutate: deposit, isPending },
  } = useKapopay();

  const schema = useMemo(() => {
    return z.object({
      amount: requiredNumber(t),
      redirectUrl: z.string(),
    });
  }, [t]);

  type FormInput = z.input<typeof schema>;
  type FormData = z.output<typeof schema>;

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInput, unknown, FormData>({
    resolver: zodResolver(schema),
    defaultValues: {
      amount: undefined,
      redirectUrl: window.location.origin,
    },
  });

  const handleFormSubmit: SubmitHandler<FormData> = (data) => {
    deposit(data);
  };

  return (
    <StyledForm
      submitTitle={t('continue')}
      onSubmit={handleSubmit(handleFormSubmit)}
      isSubmitting={isPending}
      disablePadding
    >
      <FormNumberInput
        name='amount'
        control={control}
        label={t('amount')}
        variant='outlined'
        fullWidth
        error={!!errors.amount}
        helperText={errors.amount?.message}
        disabled={isPending}
        required
      />
    </StyledForm>
  );
};

export default KapopayDepositForm;
